var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-collection-loader"},[(_vm.dataLoaded)?_vm._t("default",null,null,_vm.collectionData):_c('loader')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }